const AREA_SHAPE_ALIASES = {
  circle: 'sphere',
  sphere: 'sphere',
  radius: 'sphere',
  square: 'cube',
  cube: 'cube',
  cone: 'cone',
  line: 'line',
  cylinder: 'cylinder'
};

const toFiniteNumber = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const match = value.match(/-?\d+(?:\.\d+)?/);
    if (!match) return null;
    const parsed = Number(match[0]);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

export const normalizeAreaOfEffect = (areaOfEffect) => {
  if (!areaOfEffect || typeof areaOfEffect !== 'object' || Array.isArray(areaOfEffect)) {
    return null;
  }

  const rawShape = String(areaOfEffect.shape || areaOfEffect.type || '').trim().toLowerCase();
  const shape = AREA_SHAPE_ALIASES[rawShape] || null;

  const size = toFiniteNumber(
    areaOfEffect.size
    ?? areaOfEffect.radius
    ?? areaOfEffect.length
    ?? areaOfEffect.range
  );

  if (!shape || !Number.isFinite(size) || size <= 0) {
    return null;
  }

  const width = toFiniteNumber(areaOfEffect.width ?? areaOfEffect.thickness);
  const normalized = {
    ...areaOfEffect,
    shape,
    type: areaOfEffect.type || shape,
    size
  };

  if (shape === 'line') {
    const lineWidth = Number.isFinite(width) && width > 0 ? width : 5;
    normalized.length = Number.isFinite(toFiniteNumber(areaOfEffect.length))
      ? toFiniteNumber(areaOfEffect.length)
      : size;
    normalized.width = lineWidth;
    normalized.thickness = lineWidth;
    normalized.size = normalized.length;
  } else if (Number.isFinite(width) && width > 0) {
    normalized.width = width;
  }

  return normalized;
};

export default normalizeAreaOfEffect;
